var $ = require('jquery')

function UserProfile (raw) {
    UserProfile.prototype.init.call(this, raw)
}

$.extend(UserProfile.prototype, {
    id: null,
    user_code: null,
    first_name: null,
    last_name: null,
    sex: null,
    email: null,
    contract_type: null,
    start_from: null,
    working_site: null,
    address: null,
    post_code: null,
    phone_number: null,
    dob: null,
    start_working_time: null,
    end_working_time: null,
    break_time: null,
    group: null,
    team: null,
    role: null,
    avatar: null,
    quick_contact_name: null,
    quick_contact_phone: null,
    quick_contact_address: null,
    quick_contact_relation: null,
    quick_contact_name_vn: null,
    quick_contact_phone_vn: null,
    quick_contact_address_vn: null,
    quick_contact_relation_vn: null,
    insurance_health: null,
    insurance_welfare: null,
    insurance_employment: null,
    insurance_member: null,
    relation: null,
    old_working_place: null,
    car_ticket: null,
    furigana_name: null,
    address_vn: null,
    user_skill: null,
    user_certificate: null,

    init: function (raw) {
        var self = this

        self.user_code = raw && raw.user_code ? raw.user_code : null
        self.id = raw && raw.id ? raw.id : null
        self.first_name = raw && raw.first_name ? raw.first_name : null
        self.last_name = raw && raw.last_name ? raw.last_name : null
        self.furigana_name = raw && raw.furigana_name ? raw.furigana_name : null
        self.sex = raw && raw.sex !== undefined ? raw.sex : null
        self.email = raw && raw.email ? raw.email : null
        self.contract_type = raw && raw.contract_type ? raw.contract_type : null
        self.start_from = raw && raw.start_from ? raw.start_from : null
        self.working_site = raw && raw.working_site ? raw.working_site : null
        self.old_working_place = raw && raw.old_working_place ? raw.old_working_place : null
        self.address = raw && raw.address ? raw.address : null
        self.address_vn = raw && raw.address_vn ? raw.address_vn : null
        self.post_code = raw && raw.post_code ? raw.post_code : null
        self.phone_number = raw && raw.phone_number ? raw.phone_number : null
        self.dob = raw && raw.dob ? raw.dob : null
        self.start_working_time = raw && raw.start_working_time ? raw.start_working_time : null
        self.end_working_time = raw && raw.end_working_time ? raw.end_working_time : null
        self.break_time = raw && (raw.break_time || raw.break_time === 0) ? raw.break_time : null
        self.user_role = raw && raw.user_role ? raw.user_role : {}
        self.car_ticket = raw && raw.car_ticket ? raw.car_ticket : null
        self.user_team = raw && raw.user_team ? raw.user_team : {}
        self.avatar = raw && raw.avatar ? raw.avatar : null
        self.vti_group = raw && raw.vti_group ? raw.vti_group : null
        self.quick_contact_address = raw && raw.quick_contact_address ? raw.quick_contact_address : null
        self.quick_contact_name = raw && raw.quick_contact_name ? raw.quick_contact_name : null
        self.quick_contact_phone = raw && raw.quick_contact_phone ? raw.quick_contact_phone : null
        self.quick_contact_relation = raw && raw.quick_contact_relation ? raw.quick_contact_relation : null
        self.quick_contact_address_vn = raw && raw.quick_contact_address_vn ? raw.quick_contact_address_vn : null
        self.quick_contact_name_vn = raw && raw.quick_contact_name_vn ? raw.quick_contact_name_vn : null
        self.quick_contact_phone_vn = raw && raw.quick_contact_phone_vn ? raw.quick_contact_phone_vn : null
        self.quick_contact_relation_vn = raw && raw.quick_contact_relation_vn ? raw.quick_contact_relation_vn : null
        self.insurance_welfare = raw && raw.insurance_welfare ? raw.insurance_welfare : null
        self.insurance_member = raw && raw.insurance_member ? raw.insurance_member : null
        self.insurance_employment = raw && raw.insurance_employment ? raw.insurance_employment : null
        self.insurance_health = raw && raw.insurance_health ? raw.insurance_health : null
        self.relation = raw && raw.relation ? raw.relation : []
        self.user_skill = raw && raw.user_skill ? raw.user_skill : []
        self.user_certificate = raw && raw.user_certificate ? raw.user_certificate : []
        self.user_working_status = raw && raw.user_working_status ? raw.user_working_status : {}
    }
})

module.exports.UserProfile = UserProfile

function UserProfileList (raw) {
    UserProfileList.prototype.init.call(this, raw)
}

$.extend(UserProfileList.prototype, {
    items: null,

    init: function (raw) {
        var self = this

        var items = []

        if (raw) {
            for (var i = 0; i < Object.keys(raw).length; i++) {
                items.push(raw[Object.keys(raw)[i]])
            }
        }

        self.items = items
    },

    update: function (raw) {
        var self = this

        var items = []

        for (var i = 0; i < Object.keys(raw).length; i++) {
            items.push(raw[Object.keys(raw)[i]])
        }

        self.items = items
    }
})

module.exports.UserProfileList = UserProfileList



// WEBPACK FOOTER //
// ./client/models/userprofilemodel.js